import { DottedMenu } from "../dotted-menu";
import { FC, MouseEvent } from "react";
import { useBucketContext } from "context/bucket";
import { FolderItemProps } from "../../types";
import style from "../style.module.scss";

export const FolderItem: FC<FolderItemProps> = (props) => {
  const { item, showRemoveModal, showRenameModal, showMoveModal } = props;
  const { fetchHomePageData } = useBucketContext();
  const { name, fullPath } = item;

  const handleItemClick = async (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    await fetchHomePageData(fullPath);
  };

  const handleMoveAction = async () => {
    showMoveModal({ name, path: fullPath, isFolder: true });
  };

  const handleRenameAction = async () =>
    showRenameModal({ name: name, path: fullPath, isFolder: true });

  const handleDeleteAction = async () =>
    showRemoveModal({ name, path: fullPath, isFolder: true });

  return (
    <div className={`${style.grid} ${style["grid-item"]}`}>
      <div className="text-light">
        <i className="bi bi-folder-fill fs-3 align-middle me-2 text-primary" />
        <a
          href="/"
          className="link-light link-offset-2-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover text-truncate"
          onClick={handleItemClick}
        >
          {name}
        </a>
      </div>
      <div className="text-light"></div>
      <div className="text-light"></div>

      <DottedMenu
        id={name}
        actions={[
          { label: "Sposta", action: handleMoveAction },
          { label: "Rinomina", action: handleRenameAction },
          { label: "Elimina", action: handleDeleteAction },
        ]}
      />
    </div>
  );
};
